export default function sanitizeInput(input) {
  const escapeCharsMap = {
    '&': '&#38;',
    '<': '&#60;',
    '>': '&#62;',
    '=': '&#61;',
    '+': '&#43;',
    '(': '&#40;',
    ')': '&#41;',
    '[': '&#91;',
    ']': '&#93;',
    '/': '&#47;',
    '\\': '&#92;',
    ':': '&#58;',
    ';': '&#59;',
    '!': '&#33;',
    '#': '&#35;',
    '@': '&#64;'
  };
  if (input === null || input === void 0 ? void 0 : input.length) {
    return input.replace(/[&<>=+()[\]/\\:;!#@\s]/g, char => {
      var _a;
      return (_a = escapeCharsMap[char]) !== null && _a !== void 0 ? _a : char;
    });
  }
  return input;
}